module.exports = __webpack_public_path__ + "img/logo-all4cycling.0a913379.svg";